/* eslint-disable @typescript-eslint/no-empty-function */
import moment from 'moment';
import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Container, Row } from 'reactstrap';
import usePageTitle from '../../common/hooks/usePageTitle';
import Breadcrumbs from '../../components/Common/Breadcrumb/Breadcrumb';
import { ITable } from '../../components/Common/iComponents/iTable/ITable';
import { IPopUp } from '../../components/Common/iComponents/iPopUp/IpopUp';
import Filters from '../../components/Common/Filters/filters';
import PageTitle from '../../components/Common/MetaTagsHelper/metaTagsHelper';
import { getDynamicAttrUpdated, getDynamicFilterCF, transformCFColumnsData } from '../../helpers/tools_helper';
import { getMilestoneConfigPO, getPurchaseOrdersList } from '../../store/purchaseOrders/actions';
import { cancelFetchPO } from '../../store/purchaseOrders/saga';
import IForm from '../salesOrderList/iForm';
import { getNameClient } from './../../helpers/nameClient';
import Iloading from '../../components/Common/iComponents/iLoading/Iloading';

const PurchaseOrders = (props: any) => {
    const dispatch = useDispatch();

    const PageTitlePO = usePageTitle(props.location.pathname);

    const { data, isLoading, milestoneConfig, CountItems } = useSelector((state: any) => state.purchaseOrders);

    const groupName = 'purchaseOrdersViewList';

    const [popUpState, setpopUpState] = useState(false);
    const [updateState, setUpdateState] = useState(false);
    const [selectedRow, setSelectedRow] = useState(null);
    const [isFirstRun, setIsFirstRun] = useState(true);
    const [title, setTitle] = useState('');
    const [tableConfig, setTableConfig] = useState([]);

    const [pagination, setPagination] = useState<any>({
        sizePerPage: 50,
        page: 1,
    });
    useEffect(() => {
        dispatch(getMilestoneConfigPO());
    }, []);

    const currentDate = new Date();
    const [form, setForm] = useState({
        from: moment(currentDate).format('YYYY-MM-DD'),
        to: moment(currentDate).format('YYYY-MM-DD'),
        order: "{'createdAt' : 'DESC'}",
        dynamicFilter: '',
        dynamicFilterCF: '',
    });
    const [PurchaseOrdersList, setPurchaseOrdersList] = useState<any[]>([]);

    useEffect(() => {
        let listFinal: any[] = [];
        listFinal = transformCFColumnsData(data);
        setPurchaseOrdersList(listFinal);
    }, [data]);
    useEffect(() => {}, [data]);

    useEffect(() => {
        if (isFirstRun) {
          const filters = JSON.parse(localStorage.getItem("filterOperation") || "{}");
          if (filters[groupName]) {
            handleActionOnSearch(filters[groupName]);
          }
          setIsFirstRun(false);
        } else {
          dispatch(getPurchaseOrdersList({ form, pagination }));
        }
      }, [dispatch, form, pagination, isFirstRun]);


    useEffect(() => {
        const dataSorted = milestoneConfig.sort(function (a: any, b: any) {
            const x = a.order;
            const y = b.order;
            //compare the word which is comes first
            if (x > y) {
                return 1;
            }
            if (x < y) {
                return -1;
            }
            return 0;
        });
        dataSorted.forEach((milestone: any) => {
            milestone.hidden = !milestone.visibleInTable;
            //milestone.filter = textFilter()
        });
        setTableConfig(dataSorted);
        //setIsPageLoading(false);
    }, [milestoneConfig]);


    const handleActionOnSearch = (data: any) => {
        const filterString = getDynamicAttrUpdated(data);
        console.log(' handleActionOnSearch - filterString ..... ', filterString);
        const getFilterCF = getDynamicFilterCF(data);
        console.log(' getFilterCF .... ', getFilterCF);
        const newPagination = { ...pagination, page: 1 };
        setPagination(newPagination);
        const newForm = {
            ...data,
            order: form.order,
            dynamicFilter: filterString,
            dynamicFilterCF: getFilterCF,
        };
        setForm(newForm);
    };
    const processList = (list: any[], selectedRow: any) => {
        const t: any[] = [];
        for (const item in selectedRow) {
            list.map(function (data: { dataField: string }) {
                if (data.dataField === item)
                    t.push({
                        ...data,
                        value: selectedRow[item],
                    });
                return data;
            });
        }
        return t;
    };

    const handleActionOnRowClick = (row: any) => {
        setSelectedRow(row);
        const visibleInModalFooter = milestoneConfig.filter((x: { visibleInModalFooter: boolean }) => x.visibleInModalFooter === true);
        let titleArr = processList(visibleInModalFooter, row);
        titleArr = titleArr.map((x) => {
            return x.value;
        });
        setTitle(titleArr.join(' - '));
    };

    const handlePaginationChange = (newState: any) => {
        setPagination(newState);
    };

    const handleTableSort = (type: any, { sortField, sortOrder }: any) => {
        setForm({ ...form, order: `{'${sortField ?? 'createdAt'}' : '${sortOrder.toUpperCase()}'}` });
    };
    const onPopUpState = () => {
        setpopUpState(!popUpState);
    };

    return (
        <React.Fragment>
            <div className="page-content">
                <div className="pageContent" style={{ padding: '1px 15px 0 1px' }}>
                    <PageTitle>
                        <title>
                            {PageTitlePO.replace(/-/g, ' ')} | {getNameClient()}
                        </title>
                    </PageTitle>
                    <Container fluid>
                        <Row>
                            <Filters onSearchClicked={handleActionOnSearch} filterItems={milestoneConfig} groupName={groupName} />
                        </Row>
                        <Row>
                            <div className="container">
                                <Iloading cancelFetch={cancelFetchPO} loading={isLoading}/>
                            </div>
                            {PurchaseOrdersList.length > 0 ? (
                                milestoneConfig.length === 0 ? (
                                    <>
                                        <div>No config operations for this table</div>
                                    </>
                                ) : (
                                    <>
                                        <ITable
                                            remote={true}
                                            CountItems={CountItems}
                                            handlerPaginationState={handlePaginationChange}
                                            data={PurchaseOrdersList}
                                            fields={milestoneConfig}
                                            tableColumns={milestoneConfig}
                                            headerColorT={'bg-primary text-white'}
                                            groupName={groupName}
                                            handlePopUpState={onPopUpState}
                                            actionOnRowClick={handleActionOnRowClick}
                                            handleTableSort={handleTableSort}
                                        />
                                    </>
                                )
                            ) : (
                                <div style={{ height: 180 }} />
                            )}
                        </Row>
                    </Container>
                </div>
                <IPopUp
                    stateAdd={popUpState}
                    switchStateAdd={setpopUpState}
                    stateUpdate={updateState}
                    switchStateUpdate={setUpdateState}
                    modalTitleAdd={title}
                    modaleTitleUpdate={'Purchase Orders'}
                    icon="shopping-bag"
                    colorHeaderPop={'#101340'}
                    width="93%"
                    height="93%"
                >
                    <IForm selectedRow={selectedRow} milestoneConfig={tableConfig} groupName={groupName} columsPop={5} />
                </IPopUp>
            </div>
        </React.Fragment>
    );
};

export default PurchaseOrders;
